import { createContext, useContext } from 'react'

export const DashboardActivityContext = createContext(true)
export const useDashboardActive = () => useContext(DashboardActivityContext)
